import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RefreshCw, X } from "lucide-react";
import { TIPS, PHASE_TIPS, tipFor } from "../../lib/tips";
import { useGrowWeek, weekLabel } from "../../lib/growWeek";

const W = 280;

// Speech bubble anchored next to the animal that was tapped. `talk` = { animal, offset, rect, section }.
const place = ({ animal, rect, section }) => {
  const sw = section.width;
  const width = Math.min(W, sw - 24);
  let x = animal === "toucan" ? rect.left + rect.width * 0.5 : rect.left - width + rect.width * 0.2;
  const y = rect.top + rect.height * (animal === "toucan" ? 0.42 : 0.08);
  x = Math.max(12, Math.min(x - section.left, sw - width - 12));
  return { left: x, top: Math.max(84, y - section.top), width };
};

export const JTipBubble = ({ talk, onNext, onClose }) => {
  const week = useGrowWeek();
  const phased = talk?.animal === "toucan" && PHASE_TIPS[week];
  useEffect(() => {
    if (!talk) return undefined;
    const t = setTimeout(onClose, 14000);
    return () => clearTimeout(t);
  }, [talk, onClose]);

  return (
    <AnimatePresence>
      {talk && (
        <motion.div key={talk.animal} data-testid="hero-tip-bubble" role="status"
          initial={{ opacity: 0, scale: 0.6, y: 10 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 380, damping: 22 }}
          style={{ ...place(talk), transformOrigin: talk.animal === "toucan" ? "0% 0%" : "100% 0%" }}
          className="absolute z-30 rounded-[18px] bg-[#F6EEDC] text-[#0E2A1C] p-4 pr-9 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.7)] border-2 border-[#F2B441]">
          <span aria-hidden="true" className={`absolute -top-2 w-4 h-4 bg-[#F6EEDC] border-l-2 border-t-2 border-[#F2B441] rotate-45 ${talk.animal === "toucan" ? "left-6" : "right-6"}`} />
          <button onClick={onClose} aria-label="Cerrar consejo" data-testid="hero-tip-close"
            className="absolute top-2.5 right-2.5 w-6 h-6 grid place-items-center rounded-full hover:bg-[#0E2A1C]/10 transition-colors">
            <X className="w-3.5 h-3.5" />
          </button>
          <p className="font-mono-d text-[10px] tracking-[0.18em] uppercase text-[#1B3A8C]">
            El {TIPS[talk.animal].name.toLowerCase()} te aconseja · {phased ? weekLabel(week) : TIPS[talk.animal].role}
          </p>
          <motion.p key={talk.offset} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }}
            data-testid="hero-tip-text" className="mt-2 text-sm leading-snug font-medium">
            {tipFor(talk.animal, talk.offset, week)}
          </motion.p>
          <button onClick={onNext} data-testid="hero-tip-next"
            className="mt-3 inline-flex items-center gap-1.5 text-xs font-bold text-[#1B3A8C] hover:text-[#0E2A1C] transition-colors">
            <RefreshCw className="w-3.5 h-3.5" /> Otro consejo
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
